import React from "react";

function Color_Names() {
  return (
    <div>
      <h1>Color_Names Component</h1>
      <p>This is the Color Names tutorial page content.</p>
    </div>
  );
}

export default Color_Names;
